import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import 'react-quill/dist/quill.snow.css';
import 'rc-tooltip/assets/bootstrap_white.css';
import closeImgIcon from 'static/images/close.svg';
import checkGreen from 'static/images/checkGreen.png';
import './PaymentPageTab.scss';

const SuccessModal = ({ onClose, formLinkData }) => {
    const copyText = formLinkData?.formLink;
    const [copied, setCopied] = useState(false);
    const history = useHistory();
    const handleClose = () => {
        onClose();
        //history.push('/payment-page');
    };
    const handleCopy = e => {
        e.preventDefault();
        if (!navigator.clipboard) {
            console.error('Clipboard API not supported in this browser.');
            return;
        }
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch(() => {
                alert('Copy failed. Please try again manually.');
            });
    };
    return (
        <div className="modal-overlay success-modal">
            <div className="modal-content">
                {/* Modal Header with Close Button */}
                <div className="modal-head">
                    <img src={closeImgIcon} alt="Close" onClick={handleClose} />
                </div>
                {/* Success Image */}
                <div className="success-img">
                    <img
                        className="success-logo"
                        src={checkGreen}
                        alt="Success"
                    />
                </div>
                <div className={'message-container'}>
                    <div className="message">
                        <h4>Congratulations!</h4>
                        <p>Payment Page has been created successfully</p>
                    </div>
                </div>
                <div className="link">
                    <div className="link-to-be-copied">{copyText}</div>
                    <button
                        className="copy-icon"
                        onClick={handleCopy}
                        style={{ padding: '10px 20px', marginRight: '10px' }}
                    >
                        {copied ? 'Copied!' : 'Copy'}
                    </button>
                </div>
            </div>
        </div>
    );
};

SuccessModal.propTypes = {
    onClose: PropTypes.func,
    auth: PropTypes.object,
    paymentPageData: PropTypes.object,
};

export default SuccessModal;